/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Prompt1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Prompt from 'DesignSystem/Questions/Prompt/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Prompt1({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Prompt"
  
}) {
let widgetQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'questions',
})
let questionPromptValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'prompt',
})
let selectedAnswersValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers',
})
let questionTypeValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'type',
})
let aggregateData = fromHelpers.populateTemplate(widgetQuestionsValueData, questionPromptValueData, selectedAnswersValueData, questionTypeValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let questionSubpromptValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'subprompt',
})
  return (<React.Fragment
>
<div
  data-testid="Prompt.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Prompt
  viewPath={`${viewPath}/Prompt`}
 marginTop={dtSpaceXxs}
 marginBottom={0}
 data="widget.questions"
 data="question.prompt"
 data="selected.answers"
 data="question.type"
 aggregate="helpers.js populateTemplate"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 marginTop={dtSpaceXxs}
 data="question.subprompt"
 text={questionSubpromptValueData}
/>
</div>
{children}
</React.Fragment>)
}